import {
  HardFormFieldTypeEnum,
  IHardFormField,
  IHardFormInputParams,
  IHardFormTextAreaParams,
} from "@hardcode-kz/ui";
import { Validators } from "@angular/forms";
import { LangEnum } from "@models/interface-management/localization";
import { LocalizationService } from "@dmms/core/localization";
import { noWhitespaceValidator } from "@app/shared";

export const TranslationFieldPartialValidator = (
  baseTitle: string,
  formFieldType: HardFormFieldTypeEnum,
  requiredLang: LangEnum[] = Object.values(LangEnum),
  params: IHardFormInputParams | IHardFormTextAreaParams = {},
  hideTitle: boolean = false,
  hidePlaceholder = true,
): IHardFormField[] => {
  const langList = LocalizationService.getLangList();

  return langList.map(({ shortName, lang }) => ({
    title: !hideTitle ? `${baseTitle} (${shortName})` : "",
    name: lang,
    type: formFieldType,
    placeholder: !hidePlaceholder ? `${shortName}` : "",
    params: {
      validators: requiredLang.includes(lang as LangEnum)
        ? [Validators.required, noWhitespaceValidator()]
        : null,
      ...params,
    },
  }));
};
